import { Component } from '@angular/core';

@Component({
  selector: 'app-status-server',
  templateUrl: './status-server.component.html',
  styleUrls: ['./status-server.component.css']
})
export class StatusServerComponent {

}
